<template>
  <div :class="b()">
    <template v-for="item of visibleList">
      <MoreItem
        :id="item[idKey]"
        :key="item[idKey]"
        :data-type="item[idKey]"
      >
        <slot :item="item" />
      </MoreItem>
    </template>
    <MoreItem
      v-show="showMore"
      id="MoreBoxItem"
      :class="b('more')"
    >
      <slot
        name="more"
        :hideList="hideList"
      />
    </MoreItem>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import MoreItem from './MoreItem';

export default {
  name: 'MoreBox',
  components: { MoreItem },
  provide() {
    return {
      applySize: this.applySize
    };
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    idKey: {
      type: String,
      default: 'id'
    },
    delay: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      visibleList: this.list,
      width: 0,
      sizeMap: new Map()
    };
  },
  computed: {
    hideList() {
      return this.list.slice(this.visibleList.length);
    },
    showMore() {
      return this.hideList.length > 0;
    }
  },
  watch: {
    list: {
      handler() {
        this.debounceCalc();
      }
    }
  },
  mounted() {
    this.debounceCalc = debounce(this.calc, this.delay);
    this.resizeOb = new ResizeObserver(([entry]) => this.onResize(entry.contentRect.width));
    this.resizeOb.observe(this.$el);
    this.onResize(this.$el.getBoundingClientRect().width);
  },
  beforeDestroy() {
    this.resizeOb?.unobserve(this.$el);
    this.resizeOb.disconnect();
    this.resizeOb = null;
    this.sizeMap.clear();
    this.debounceCalc.cancel();
    this.debounceCalc = null;
  },
  methods: {
    applySize(id, size) {
      if (!size) {
        this.sizeMap.delete(id);
      } else {
        this.sizeMap.set(id, size);
      }
    },
    onResize(width) {
      this.width = width;
      this.debounceCalc();
    },
    calc() {
      this.visibleList = this.list || [];
      if (this.visibleList.length <= 1) {
        return;
      }
      requestAnimationFrame(() => {
        const moreWidth = this.sizeMap.get('MoreBoxItem') || 0;
        let sumWidth = 0;
        for (let i = 0; i < this.list.length; i++) {
          const item = this.list[i];
          const { [this.idKey]: id } = item;
          const width = this.sizeMap.get(id);
          const nextSumWidth = sumWidth + width;
          if (nextSumWidth > this.width) {
            let lastIndex = i;
            if (sumWidth + moreWidth > this.width) {
              lastIndex -= 1;
            }
            this.visibleList = this.list.slice(0, Math.max(1, lastIndex));
            return;
          }

          sumWidth = nextSumWidth;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
